export const environment = {
  production: true,
  webpushVapidKey: 'BGcZH-S2F64BDKhlGfaKpcSwOFq2qeiLsNzqubxY7ct2r-nw6Ckdhayr87r3khp5F_ZUarpSeRuonbW9gLcj5qA',
  apiUrl: 'https://dresschange-demo-api.ud4.ru/',
  mediaUrl: 'https://dresschange-media.ud4.ru/'
};
